import { AppBar, Toolbar, Typography, Link } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import React from 'react'
import { useCustomTranslation } from '../../Hooks/useCustomTranslation'
import i18next from 'i18next'
import { DefaultRootState, useTypedSelector } from '../../State/RootReducer'

const useStyles = makeStyles()(theme => ({
  appBar: {
    top: 'auto',
    bottom: 0,
    backgroundColor: theme.palette.grey.grey01,
  },
  toolbar: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: theme.palette.common.white,
  },
}))

interface FooterProps {
  className?: string
}
const Footer: React.VFC<FooterProps> = ({ className }) => {
  const { t } = useCustomTranslation()
  const { classes, cx } = useStyles()
  const app = useTypedSelector((state: DefaultRootState) => state.app.app)
  let companyLink
  let companyName
  let impressumLink
  let dataPrivacyLink

  switch (app) {
    case 'hager': {
      companyLink = 'https://www.hager.com'
      companyName = 'Hager'
      switch (i18next.language) {
        case 'de': {
          impressumLink = 'https://www.hager.com/_de/impressum'
          break
        }
        case 'en': {
          impressumLink = 'https://www.hager.com/_en/imprint'
          break
        }
        case 'fr': {
          impressumLink = 'https://hager.com/_fr/mentions-legales'
          break
        }
        default: {
          impressumLink = 'https://www.hager.com/_de/impressum'
        }
      }
      break
    }
    case 'e3dc': {
      companyLink = 'https://www.e3dc.com'
      companyName = 'E3/DC'
      switch (i18next.language) {
        case 'de': {
          impressumLink = 'https://www.e3dc.com/impressum'
          dataPrivacyLink = '/privacy-protection'
          break
        }
        case 'en': {
          impressumLink = 'https://www.e3dc.com/en/imprint/'
          dataPrivacyLink = 'https://www.e3dc.com/en/data-protection'
          break
        }
        case 'fr': {
          impressumLink = 'https://www.e3dc.com/ch-fr/mentions-legales'
          dataPrivacyLink = 'https://www.e3dc.com/ch-fr/protection-des-donnees'
          break
        }
        default: {
          impressumLink = 'https://www.e3dc.com/impressum'
          dataPrivacyLink = '/privacy-protection'
        }
      }
      break
    }
    default: {
      companyLink = 'https://www.e3dc.com'
      companyName = 'E3/DC'
      impressumLink = 'https://www.e3dc.com/impressum'
      dataPrivacyLink = '/privacy-protection'
    }
  }
  return (
    <AppBar position="fixed" className={cx(classes.appBar, className)}>
      <Toolbar className={classes.toolbar}>
        <Link href={companyLink} variant="body1" className={classes.text}>
          {companyName}
        </Link>
        <Typography variant="body1">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</Typography>
        <Link href={impressumLink} variant="body1" className={classes.text}>
          {t('shell.footer.about')}
        </Link>
        {dataPrivacyLink && (
          <>
            <Typography variant="body1">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</Typography>
            <Link href={dataPrivacyLink} variant="body1" className={classes.text}>
              {t('shell.footer.data-privacy')}
            </Link>
          </>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default Footer
